import {
  Icon3DLine,
  IconBinocularsGray,
  IconBuildings,
  IconCctvLine,
  IconChainLink,
  IconClockGray,
  IconCloud,
  IconGlobal,
  IconRoom,
  IconRoute,
  IconRulerGray,
  IconShare,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';

import image1 from '@src/assets/images/digitaltwin/image/image1.avif';
import image2 from '@src/assets/images/digitaltwin/image/image2.avif';

import gis from '@src/assets/images/digitaltwin/video/gis.mp4';
import weather from '@src/assets/images/digitaltwin/video/weather.mp4';
import buildings from '@src/assets/images/digitaltwin/video/buildings.mp4';
import tracking from '@src/assets/images/digitaltwin/video/tracking.mp4';
import traffic from '@src/assets/images/digitaltwin/video/traffic.mp4';
import airplane from '@src/assets/images/digitaltwin/video/airplane.mp4';
import cctv from '@src/assets/images/digitaltwin/video/cctv.mp4';

export default {
  type: 'Giải pháp thành phố',

  banner: {
    title: 'Quản lý hạ tầng đô thị hiệu quả bằng công nghệ Digital Twin.',
    desc: 'Giám sát trạng thái và vận hành hạ tầng đô thị theo thời gian thực bằng công nghệ Digital Twin, quản lý hiệu quả, nâng cao độ ổn định và hiệu suất vận hành.',
  },

  video: {
    title: 'Nắm bắt toàn bộ trạng thái hạ tầng đô thị bằng công nghệ Digital Twin.',
    desc: 'Ứng dụng công nghệ Digital Twin để tích hợp và trực quan hóa dữ liệu trạng thái và vận hành của các hạ tầng quan trọng trong thành phố theo thời gian thực, giúp quản lý có hệ thống và hiệu quả.',
    // play: mainVideo,
    image: image1,
  },

  func: [
    {
      theme: 'Kiểm tra và quản lý trạng thái hạ tầng đô thị theo thời gian thực bằng Digital Twin.',
      title: 'Hiển thị 3D theo thời gian thực',
      desc: 'Mô hình hóa chính xác các tòa nhà và cơ sở vật chất trong thành phố bằng mô hình 3D, cho phép quan sát trực quan thông tin theo thời gian thực, nhanh chóng nắm bắt tình trạng vận hành và quản lý hiệu quả.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Nắm bắt trạng thái theo thời gian thực',
      icon2: IconClockGray,
      video: gis,
    },
    {
      title: 'Kết nối dữ liệu thời tiết và không khí theo thời gian thực',
      desc: 'Đồng bộ dữ liệu thời tiết thực tế (mưa, tuyết, v.v.) với hệ thống theo thời gian thực, tái hiện chính xác điều kiện khí tượng, mang lại trải nghiệm chân thực và khả năng ứng phó chính xác.',
      sub1: 'Đồng bộ dữ liệu nhanh',
      icon1: IconTvocGray,
      sub2: 'Theo dõi vị trí theo thời gian thực',
      icon2: IconBinocularsGray,
      video: weather,
    },
    {
      title: 'Hiển thị thông tin tòa nhà theo thời gian thực',
      desc: 'Giám sát tình trạng cơ sở vật chất và lịch bảo trì theo thời gian thực, dự đoán sự cố thiết bị và tiêu thụ năng lượng qua dữ liệu cảm biến, hỗ trợ quản lý hiệu quả và thân thiện môi trường.',
      sub1: 'Theo dõi vị trí theo thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      video: buildings,
    },
    {
      title: 'Hiển thị bản đồ trong nhà theo thời gian thực',
      desc: 'Cập nhật thông tin vật thể và người di chuyển trong nhà theo thời gian thực, nắm bắt chính xác luồng di chuyển và tình hình an ninh, hỗ trợ quản lý và phản ứng nhanh.',
      sub1: 'Thiết lập khu vực linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Hỗ trợ nhiều khu vực',
      icon2: IconTagGray,
      video: tracking,
    },
    {
      theme: 'Tích hợp thông tin di chuyển và an toàn toàn thành phố, hỗ trợ vận hành hiệu quả.',
      title: 'Quản lý di chuyển của người và phương tiện theo thời gian thực',
      desc: 'Phân tích thông tin di chuyển của phương tiện và người trong thành phố theo thời gian thực, phòng tránh ùn tắc giao thông và phản ứng kịp thời với sự cố an toàn, hỗ trợ vận hành thành phố nhanh chóng, chính xác.',
      sub1: 'Thiết lập khu vực linh hoạt',
      icon1: IconTagGray,
      sub2: 'Hỗ trợ nhiều khu vực',
      icon2: IconZoneGray,
      image: image2,
    },
    {
      title: 'Kết nối thông tin giao thông công cộng theo thời gian thực',
      desc: 'Cung cấp thông tin vận hành thời gian thực của xe buýt, tàu điện ngầm, đề xuất tuyến đường tối ưu và giảm thiểu ùn tắc, nâng cao hiệu quả giao thông đô thị.',
      sub1: 'Độ chính xác cao',
      icon1: IconZoneGray,
      sub2: 'Hỗ trợ nhiều khu vực',
      icon2: IconTagGray,
      video: traffic,
    },
    {
      title: 'Kết nối thông tin chuyến bay theo thời gian thực',
      desc: 'Kết nối thông tin chuyến bay theo thời gian thực với hệ thống, thông báo ngay khi có thay đổi hoặc chậm chuyến, tăng tính trơn tru cho hành trình và nâng cao hiệu quả vận hành.',
      sub1: 'Triển khai nhanh',
      icon1: IconTagGray,
      sub2: 'Hỗ trợ nhiều khu vực',
      icon2: IconTagGray,
      video: airplane,
    },
    {
      title: 'Giám sát và quản lý video CCTV theo thời gian thực',
      desc: 'Kết nối video CCTV trong thành phố theo thời gian thực, phát hiện ngay dấu hiệu bất thường, phòng ngừa tội phạm, quản lý tình hình giao thông nhanh chóng, đảm bảo an toàn thành phố hiệu quả.',
      sub1: 'Trực quan thời gian thực',
      icon1: IconShareGray,
      sub2: 'Hỗ trợ nhiều khu vực',
      icon2: IconTagGray,
      video: cctv,
    },
  ],

  subfunc: {
    title: 'Tóm tắt tính năng chính',
    desc: '',

    data: [
      {
        icon: Icon3DLine,
        title: 'Hiển thị 3D theo thời gian thực',
        desc: 'Hỗ trợ dựng hình 3D và giám sát cơ sở vật chất theo thời gian thực',
      },
      {
        icon: IconCloud,
        title: 'Kết nối thông tin thời tiết theo thời gian thực',
        desc: 'Đồng bộ dữ liệu thời tiết thực tế với hệ thống theo thời gian thực',
      },
      {
        icon: IconBuildings,
        title: 'Xem thông tin tòa nhà',
        desc: 'Giám sát tình trạng tòa nhà và tiêu thụ năng lượng theo thời gian thực',
      },
      {
        icon: IconRoom,
        title: 'Hiển thị bản đồ trong nhà',
        desc: 'Cung cấp bản đồ vị trí vật thể và con người trong nhà theo thời gian thực',
      },
      {
        icon: IconRoute,
        title: 'Phân tích di chuyển người & phương tiện',
        desc: 'Phân tích dữ liệu di chuyển của phương tiện và người theo thời gian thực',
      },
      {
        icon: IconChainLink,
        title: 'Kết nối thông tin giao thông công cộng',
        desc: 'Cung cấp vị trí thời gian thực của xe buýt, tàu điện ngầm...',
      },
      {
        icon: IconShare,
        title: 'Kết nối thông tin chuyến bay',
        desc: 'Kết nối dữ liệu vận hành chuyến bay với hệ thống theo thời gian thực',
      },
      {
        icon: IconCctvLine,
        title: 'Giám sát CCTV theo thời gian thực',
        desc: 'Phân tích video CCTV theo thời gian thực để đảm bảo an toàn thành phố',
      },
      {
        icon: IconGlobal,
        title: 'Kết nối nền tảng GIS',
        desc: 'Quản lý hiệu quả dữ liệu không gian thông qua liên kết GIS',
      },
      {
        icon: IconChainLink,
        title: 'Kết nối API hệ thống bên ngoài',
        desc: 'Hỗ trợ tích hợp linh hoạt dữ liệu từ nhiều hệ thống khác nhau',
      },
    ],
  },

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Gói sản phẩm',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
